import { UUID } from '../utils/UUID';
export function addBaseMessageProperties({
  type,
  name,
  version
}) {
  return {
    type,
    format: `${name}_shared-worker-versioning`,
    id: UUID(`${name}_${type}`),
    version
  };
}